export const focusedThreadIdQueryParam = 'focusedThreadId';
export const focusedReplyIdQueryParam = 'focusedReplyId';
export const selectedSingleThreadControlNameQueryParam = 'thread';
export const commentCreateDraftLocalStorageKey = 'comment-create-draft';
export const commentDraftLocalStoragePrefix = 'comment-draft';
